// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3ikJ_","large":"styles_large__2sgFP"};